var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.b(),_vm.className],style:(_vm.styleSizeName),on:{"click":_vm.handleClick}},[_c('div',{style:([_vm.styleChartName,_vm.styleImgName])})])
}
var staticRenderFns = []

export { render, staticRenderFns }